import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>1. Mõisted ja tõlgendamine</Summary>
        <Details>
          <ul>
            <li>
              1.1. Hinnakiri on Iseteeninduses avaldatud ja Iseteeninduse
              tooteid ja teenuseid käsitlev hinnakiri, mis on Iseteeninduse
              Kasutajatingimuste lahutamatu osa.
            </li>
            <li>
              1.2. Iseteenindus on Portaalihalduri poolt hallatav teenuste ja
              toodete keskkond internetiaadressil [xx], mille Kliendid saavad
              kasutada Portaalihalduri pakutavaid interaktiivseid teenuseid, muu
              hulgas elektroonilist süsteemi, milles Portaalihaldur esitab
              olemasolevad Võlausaldajale kuuluvad nõuded, et hõlbustada
              Portaali kaudu Kliendi poolt Nõude või nende osade tasumist
              Võlausaldajale.
            </li>
            <li>
              1.3. Kasutajatingimused on käesolevad tingimused, mida
              kohaldatakse iga Iseteeninduse Kliendi suhtes, millega
              reguleeritakse Portaalihalduri ja Kliendi vahelisi lepinguid ning
              milles on kirjeldatud Portaalihalduri poolt pakutavate teenuste
              kasutamise tingimusi.
            </li>
            <li>
              1.4. Kliendikonto on Kliendiga seotud profiil Iseteeninduse
              kasutamiseks, mida kasutatakse Kliendi tuvastamiseks, Kliendi
              ligipääsuks toodetele ja teenustele, nende eest tasumiseks ning
              seadistuste muutmiseks ja salvestamiseks.
            </li>
            <li>1.5. Klient on füüsiline isik, kes kasutab Iseteenindust.</li>
            <li>
              1.6. Nõue on laenulepingust tulenev rahaline nõue Kliendi vastu.
            </li>
            <li>
              1.7. Pool(ed) on ainsuses sõltuvalt kontekstist kas Portaalihaldur
              või Klient, mitmuses mõlemad.
            </li>
            <li>
              1.8. Portaali omanik ja Portaalihaldur on PlusPlus Baltic OÜ
              (registrikood 12273105, aadress Tartu mnt 83, 10115 Tallinn).
            </li>
            <li>
              1.9. Privaatsuspoliitika on Iseteeninduse veebisaidil kättesaadav
              dokument, milles on avaldatud teave selle kohta, kuidas
              Iseteeninduses isikuandmeid töödeldakse.
            </li>
            <li>
              1.10. Tasud on Hinnakirjas esitatud tasud erinevate Iseteeninduses
              pakutavate toodete ja teenuste eest, mille Klient maksab
              Portaalihaldurile.
            </li>
            <li>
              1.11. Tellimus on Portaalihalduri ja Kliendi vahel sõlmitud
              ostu-müügileping Tellimuspaketi või muu Hinnakirjas märgitud
              teenuse või toote ostmiseks.
            </li>
            <li>
              1.12. Tellimuspakett on Kliendi poolt valitav pakett Iseteeninduse
              erinevate teenustele ligipääsu saamiseks teatud hinnaga.
            </li>
            <li>
              1.13. Tootekaart on Tellimuspakettide kirjeldus ja tingimused, mis
              on Iseteeninduse Kasutajatingimuste lahutamatu osa.
            </li>
            <li>
              1.14. Tööpäev on iga päev, mis ei ole laupäev, pühapäev ega
              riigipüha Eestis.
            </li>
            <li>
              1.15. Võlausaldaja on juriidiline isik, kelle Nõuded on
              Iseteeninduses kuvatud.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>2. Üldsätted</Summary>
        <Details>
          <ul>
            <li>
              2.1. Käesolevad Kasutajatingimused reguleerivad Iseteeninduse
              kasutamist Klientide poolt.
            </li>
            <li>2.2. Kasutajatingimused on kättesaadavad veebilehel [xx].</li>
            <li>
              2.3. Iseteenindust kasutades kinnitab Klient, et on käesolevate
              Kasutajatingimustega ning Kasutajatingimuse osaks oleva
              Tootekaardi ja Hinnakirjaga tutvunud, mõistab neid ja nõustub
              nendega. Kasutajatingimused on Kliendi ja Portaalihalduri vahel
              siduvad.
            </li>
            <li>
              2.4. Iseteeninduse kasutamise eelduseks on Kasutajatingimustega
              nõustumine.
            </li>
            <li>
              2.5. Iseteeninduses avaldatud informatsioon pärineb
              Portaalihaldurile teadaolevat usaldusväärsetest allikatest.
              Portaalihaldur teeb oma parima, et Iseteeninduses avaldatud
              informatsioon oleks täpne, täielik ja asjakohane, kuid ei anna
              selles osas mingeid garantiisid, otseseid ega kaudseid kinnitusi.
            </li>
            <li>
              2.6. Iseteeninduses avaldatud informatsiooni ei tohi käsitleda kui
              pakkumise, nõuande või soovitusena osta, müüa või muul viisil teha
              finantstehinguid, astuda lepingutesse või teha muid tehinguid,
              välja arvatud juhul, kui on selgelt väljendatud teisiti.
            </li>
            <li>
              2.7. Kõik Iseteeninduse vahendusel tehtud maksed tasutakse eurodes
              (€).
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>3. Kliendiks registreerimine ja sisselogimine</Summary>
        <Details>
          <ul>
            <li>
              3.1. Iseteeninduses pakutavate toodete ja teenuste ostmiseks tuleb
              isikul registreerida Kliendiks.
            </li>
            <li>
              3.2. Iseteeninduse Kliendiks registreeruda saavad kõik füüsilised
              isikud, kelle vastu on Võlausaldajal sissenõutavaks muutunud Nõue.
            </li>
            <li>
              3.3. Iseteeninduse kasutajaks registreerimisel
              Kasutajatingimustega nõustudes avaldab ja kinnitab Klient, et:
              <ul>
                <li>
                  3.3.1. ta on Kasutajatingimustega tutvunud, neist aru saanud
                  ning kohustub neid Iseteeninduse kaudu pakutavate toodete ja
                  teenuste ostmisel ning kasutamisel järgima;
                </li>
                <li>
                  3.3.2. tema isikuandmeid töödeldakse kooskõlas
                  Privaatsuspoliitikaga;
                </li>
                <li>
                  3.3.3. ta on vähemalt 18-aastane õigus- ja teovõimeline isik;
                </li>
                <li>
                  3.3.4. tema suhtes ei rakendata rahvusvahelist
                  finantssanktsiooni.
                </li>
              </ul>
            </li>
            <li>
              3.4. Iseteenindusse registreerumisel tuleb läbida käesolevate
              Kasutajatingimuste punktis 4 kirjeldatud veebipõhine
              tuvastusprotsess.
            </li>
            <li>
              3.5. Iga kord, kui Klient soovib siseneda oma Iseteeninduse
              Kliendikontole, tuleb sisse logida, kasutades selleks enda
              eelistatud viisi, milleks võib olla:
              <ul>
                <li>3.5.1. Mobiil-ID;</li>
                <li>3.5.2. Smart-ID; või</li>
                <li>3.5.3. ID kaart.</li>
              </ul>
            </li>
            <li>
              3.6. Kui Portaalihalduril on tekkinud kahtlus, et Kliendikontole
              on sisenetud loata, võib Portaalihaldur Kliendi blokeerida.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>4. Kliendi identifitseerimine</Summary>
        <Details>
          <ul>
            <li>
              4.1. Kliendi isikusamasus tuvastatakse Portaalihalduri poolt
              aktsepteeritud digitaalset isikutuvastamist võimaldava vahendi
              kaudu (Mobiil ID, Smart ID, ID kaart).
            </li>
            <li>
              4.2. Klient esitab isikusamasuse tuvastamiseks Portaalihalduri
              poolt nõutud andmed ja dokumendid.
            </li>
            <li>
              4.3. Portaalihalduril on õigus nõuda täiendavaid dokumente- ja
              infot, et kontrollida isikusamasust või isiku esitatud teavet.
              Portaalihaldur võib Iseteeninduses isikusamasuse tuvastamise
              protsessi muuta.
            </li>
            <li>
              4.4. Portaalihalduril on õigus teha Kliendi poolt esitatud
              dokumendist koopia või võimaluse korral jätta endale dokumendi
              originaali.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>5. Iseteeninduse kasutamine</Summary>
        <Details>
          <ul>
            <li>
              5.1. Iseteeninduse vahendusel Tellimuspaketi valides saab Klient
              läbi Kliendikonto hallata oma Nõuet, tasuda Nõude eest, näha
              Nõudega seotud teavet ning teha muid toiminguid või tellida
              lisateenuseid, arvestades Iseteeninduse tehnilisi võimalusi.
            </li>
            <li>
              5.2. Kliendil on võimalus Tellimuspakett valida minimaalselt üheks
              aastaks.
            </li>
            <li>
              5.3. Tellimuspakettide kirjeldused on kättesaadavad Tootekaardil.
            </li>
            <li>
              5.4. Iseteeninduses kuvatud Nõue on koheselt sissenõutav ning
              Nõudelt viivise arvestamine lõpeb Nõude täielikul tasumisel.
            </li>
            <li>
              5.5. Klient saab valitud Tellimuspaketti hallata, muuta ja
              lõpetada Iseteeninduse vahendusel läbi Kliendikonto vastavalt
              käesolevates Kasutajatingimustes sätestatule ning konkreetse
              Tellimuspaketi tingimustele.
            </li>
            <li>
              5.6. Klient saab lisaks Tellimuspaketile osta ka muid teenuseid
              vastavalt kehtivale Hinnakirjale ja Kasutajatingimustes
              sätestatule.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>6. Kliendi õigused ja kohustused</Summary>
        <Details>
          <ul>
            <li>
              6.1. Kliendil on õigus kasutada Iseteenindust vastavalt
              käesolevatele Kasutajatingimustele ning enda poolt valitud
              Tellimuspaketile.
            </li>
            <li>
              6.2. Kliendil on õigus osta lisateenuseid vastavalt käesolevatele
              Kasutajatingimustele ja kehtivale Hinnakirjale.{" "}
            </li>
            <li>
              6.3. Klient teavitab Portaalihaldurit viivitamata
              Portaalihaldurile esitatud teabe, (isiku)andmete ja/või
              dokumentide muutumisest.
            </li>
            <li>
              6.4. Klient saab Iseteeninduse kasutamiseks valida ainult ühe
              Tellimuspaketi korraga, seda mh ka olukorras, kus kui Kliendil on
              mitu rahalist kohustust Võlausaldaja ees.
            </li>
            <li>
              6.5. Klient vastutab õiguslike tagajärgede eest, mis tulenevad mis
              tahes maksetest, maksekorraldustest, juhistest, taotlustest,
              dokumentidest jm teabest, mille Klient on Iseteeninduses esitanud.
            </li>
            <li>
              6.6. Klient kohustub hoidma Iseteenindusse sisse logimiseks või
              isikusamasuse tuvastamiseks tarvilikke andmeid ja vahendeid (nt
              sülearvuti, mobiiltelefon), sh ID kaarti, paroole ja
              kasutajatunnuseid nii, et need ei satuks kolmandate isikute
              valdusesse.
            </li>
            <li>
              6.7. Klient kohustub hindama kõigi Iseteeninduses avaldatud
              dokumentide ja informatsiooni täpsust, sobivust ja asjakohasust
              Kliendile. Portaalihaldur soovitab vajaduse korral täpsustuste
              saamiseks pöörduda Portaalihalduri poole.
            </li>
            <li>
              6.8. Klient kohustub Iseteenindust kasutades käituma
              heaperemehelikult ja lugupidavalt.
            </li>
            <li>
              6.9. Klient ei tohi kasutada Iseteenindust mis tahes
              ebaseaduslikul viisil või õigusrikkumise toimepanemiseks.
            </li>
            <li>
              6.10. Kliendil ei ole lubatud kasutada Iseteenindust programmide
              vahendusel, mis saadavad Iseteenindusele automaatseid päringuid.
              Samuti on keelatud robotite, jälitus- ja otsinguseadmete, andmete
              sorteerija ja muude automaatsete andmesisestus- ja töötlusseadmete
              kasutamine.
            </li>
            <li>
              6.11. Klient ei tohi kasutada Iseteenindust selle kättesaadavuse
              või funktsionaalsuse seireks või muudel konkureerimise
              eesmärkidel.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>7. Portaalihalduri õigused ja kohustused</Summary>
        <Details>
          <ul>
            <li>
              7.1. Portaalihaldur kohustub tagama Kliendile võimaluse kasutada
              Iseteenindust vastavalt käesolevatele Kasutajatingimustele.
            </li>
            <li>
              7.2. Portaalihaldur tagab Klienti puudutava teabe
              konfidentsiaalsuse ning avaldab Klienti puudutavat teavet
              kolmandatele isikutele ainult Privaatsuspoliitikas ja seadustes
              nimetatud juhtudel.
            </li>
            <li>
              7.3. Portaalihaldur käitleb Kliendi (isiku)andmeid üksnes
              ulatuses, mis on vajalik Iseteeninduse toodete ja teenuste
              pakkumiseks, nende edasi arendamiseks või parandamiseks.
            </li>
            <li>
              7.4. Portaalihalduril on õigus Iseteeninduse funktsioone, tooteid,
              teenuseid, nende mahtu ja osutamise korda muuta ning teha
              vastavaid uuendusi Iseteeninduse paremaks toimimiseks.
            </li>
            <li>
              7.5. Portaalihalduri kontaktandmed ning teadete edastamise viisid
              on avaldatud Portaalihalduri veebilehel. Kontaktandmete muutmisel
              ei ole Portaalihaldur kohustatud Klienti sellest eraldi teavitama,
              välja arvatud juhul, kui Kasutajatingimustes või muudes sõlmitud
              lepingutes on kokku lepitud teisiti või see tuleneb seadusest.
            </li>
            <li>
              7.6. Portaalihaldur ei vastuta häirete ja rikete eest
              Iseteeninduse töös, kui nende põhjuseks on häired ja rikked
              Kliendi seadme töös, sobimatute- või litsentseerimata seadmete-
              või programmide kasutamine, elektrikatkestused, Kliendi arvuti
              mittevastavus Iseteeninduse kasutamiseks vajalike tehnoloogiliste
              nõuetega või vääramatu jõud (loodusjõud, riigivõimuorganite
              tegevus jm).
            </li>
            <li>
              7.7. Portaalihaldur ei vastuta Kliendile tekkinud kahju eest, kui
              Kliendi poolt volitamata isik siseneb Kliendi andmeid ja paroole
              kasutades Iseteenindusse ja teeb Kliendi nimel makseid, ostab
              tooteid ja teenuseid, edastab dokumente või teeb muid
              Iseteeninduse võimaldatud tegevusi.{" "}
            </li>
            <li>
              7.8. Juhul kui Klient ei täida punktis 6 e nimetatud kohustust, on
              Portaalihalduril õigus eeldada, et Kliendi varem esitatud teave,
              (isiku)andmed ja dokumendid on õiged, kuni Klient ei teata
              vastupidist.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>8. Tasumine</Summary>
        <Details>
          <ul>
            <li>
              8.1. Klient on kohustatud tasuma Iseteeninduse vahendusel
              ostetavate toodete ja teenuste eest nende ostmise ajal kehtiva
              Hinnakirja alusel.
            </li>
            <li>
              8.2. Kliendil on võimalus Nõude eest tasuda:
              <ul>
                <li>
                  8.2.1. kasutades pangalinki Iseteeninduse tehnilisi võimalusi
                  arvestades;
                </li>
                <li>
                  8.2.2. pangaülekandega Kliendile määratud viitenumbrit ja/või
                  selgitust kasutades; või
                </li>
                <li>
                  8.2.3. pangakaardiga, mille puhul debiteeritakse tasutud summa
                  Kliendi pangaarvelt.
                </li>
              </ul>
            </li>
            <li>
              8.3. Kliendil on Iseteeninduse vahendusel ostetavate toodete ja
              teenuste eest tasuda:
              <ul>
                <li>
                  8.3.1. kasutades pangalinki Iseteeninduse tehnilisi võimalusi
                  arvestades;
                </li>
                <li>
                  8.3.2. mobiiliga, mille puhul lisatakse tasutud summa Kliendi
                  telefoniarvele; või
                </li>
                <li>
                  8.3.3. pangakaardiga, mille puhul debiteeritakse tasutud summa
                  Kliendi pangaarvelt.
                </li>
              </ul>
            </li>
            <li>
              8.4. Tellimuspaketti on Kliendil võimalik tellida püsimaksega, mis
              tähendab püsimakset pangakaardi või mobiiliga.
            </li>
            <li>
              8.5. Tellimuspaketi eest tasumisel on Kliendil võimalik valida
              kuu- või aastapõhise tasumise vahel.
            </li>
            <li>
              8.6. Püsimakse puhul pikeneb Tellimuspakett automaatselt kuni
              Klient ei ole seda tingimust muutnud ehk Tellimuspaketi
              automaatset pikenemist tühistanud enne uue tellimusperioodi
              algust.
            </li>
            <li>
              8.7. Püsimaksega Tellimuspaketi puhul luuakse uus Tellimus 1 (üks)
              kuu enne tellimusperioodi lõppu.
            </li>
            <li>
              8.8. Tellimuspaketi eest tasumise puhul toimuvad maksed
              automaatselt selleks Kliendi poolt varem valitud makseviisi
              kasutades, arvestades Iseteeninduse tehnilisi võimalusi.
            </li>
            <li>
              8.9. Pangakaardiga Nõude ja Hinnakirja alusel ostetavate
              ühekordsete teenuste eest tasutud makseid vahendab Maksekeskus AS.
            </li>
            <li>
              8.10. Pangakaardiga Tellimuspaketi eest tasutud püsimakseid
              vahendab Stripe Payments Europe Limited.
            </li>
            <li>
              8.11. Mobiiliga Tellimuspaketi eest tasutud püsimakseid vahendab
              Zlick LTD.
            </li>
            <li>
              8.12. Tellimuspaketi vahetamise korral hakkab uue Tellimuspaketi
              kuutasu kehtima tagasiulatuvalt paketivahetuskuu alguskuupäevast.
            </li>
            <li>
              8.13. Tellimuspaketi lõpetamisel või muutmisel ettemaksu ei
              tagastata, v.a kui Tellimuspaketi Tootekaardil on ette nähtud
              teisiti. Portaalihalduril on õigus Tellimuspaketi eest tasutud
              summasid tasaarveldada uue Tellimuspaketi valimisel selle eest
              tasumisele kuuluvate summadega.
            </li>
            <li>
              8.14. Tellimuspaketi või muude Hinnakirjas toodud toodete ja
              teenuste eest mitteõigeaegsel tasumisel on Portaalihalduril õigus
              nõuda maksega viivitamise eest viivist 0,06% päevas.
            </li>
            <li>8.15. Tellimuspaketi tasu ei sõltu Nõuete arvust.</li>
            <li>
              8.16. Olukorras, kus Kliendil on mitu Nõuet ning Klient tasub ilma
              viitenumbrit ja/või selgitust kasutamata, kuulub vastavalt
              seadusele esimesena täitmisele järjekorras kõige varem
              sissenõutavaks muutunud Nõue.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>
          9. Iseteeninduse Kasutajatingimused, nende muutmine ja Hinnakirja
          muutmine
        </Summary>
        <Details>
          <ul>
            <li>
              9.1. Portaalihalduril on õigus Kasutajatingimusi, Hinnakirja ja
              Tootekaarti ühepoolselt muuta.
            </li>
            <li>
              9.2. Portaalihaldur teavitab Kliente Iseteeninduse
              Kasutajatingimuste, Tootekaardi ja Hinnakirja muudatustest
              vähemalt 1 (üks) kuu ette, edastades sellekohase teabe Klientidele
              elektrooniliselt e-posti teel või Iseteeninduse vahendusel.{" "}
            </li>
            <li>
              9.3. Kui Klient ei nõustu Kasutajatingimuste ja/või Hinnakirja
              muudatustega, on Kliendil õigus ühe (1) kuu jooksul alates
              muudatuste avaldamisest lepinguline suhe Portaalihalduriga üles
              öelda antud Kasutajatingimuste punktis 10 sätestatud korras.
            </li>
            <li>
              9.4. Juhul kui Klient ei avalda ühe (1) kuu jooksul tahet
              leping(ud) lõpetada, loetakse ta muudetud Kasutajatingimuste ning
              selle lisadega nõustunuks.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>10. Tellimuspaketi muutmine ja lõpetamine</Summary>
        <Details>
          <ul>
            <li>
              10.1. Kliendil on võimalik Tellimuspaketti muuta, valides
              kehtivast Tellimuspaketist pikema kestvusega Tellimuspakett.
            </li>
            <li>
              10.2. Klient võib püsimaksega Tellimuspaketi igal ajal lõpetada,
              esitades selleks Portaalihaldurile avalduse kirjalikku
              taasesitamist võimaldavas vormis.
            </li>
            <li>
              10.3. Püsimaksega Tellimuspaketi automaatse pikenemise tühistamise
              korral kestab Tellimuspakett kuni ettemakse lõpuni. Ettemakstud
              raha ei tagastata.
            </li>
            <li>
              10.4. Portaalihaldur ei taga Tellimuspaketi täitmist ja võib
              ligipääsu Iseteenindusele piirata või selle peatada juhul kui:
              <ul>
                <li>
                  10.4.1. Klient ei tasu toote või teenuse eest kokkulepitud
                  summat maksetähtajaks ning ei täida antud kohustust neljateist
                  (14) päeva jooksul;
                </li>
                <li>
                  10.4.2. Klient rikub Kasutajatingimusi, muid Portaalihalduri
                  poolt kehtestatud tingimusi või ei nõustu tema isikuandmete
                  töötlemisega vastavalt Privaatsuseeskirjale;
                </li>
                <li>
                  10.4.3. Klient kasutab Iseteeninduses automaatseid vahendeid
                  või programme selle kasutamiseks (nagu selgitatud punktis 6
                  d).
                </li>
              </ul>
            </li>
            <li>
              10.5. Tellimuspaketi lõppemine ei mõjuta võimalike muude
              Iseteeninduse vahendusel sõlmitud lepingute kehtivust või enne
              Tellimuspaketi ostmist kehtinud kohustusi Võlausaldaja ees.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>11. Intellektuaalne omand</Summary>
        <Details>
          <ul>
            <li>
              11.1. Kõik Iseteeninduse ja selles avaldatud teostega seotud
              autoriõigused ja autoriõigustega kaasnevad õigused kuuluvad
              Portaali omanikule.
            </li>
            <li>
              11.2. Iseteeninduses on kasutatud kaubamärke, mille omanikuks on
              PlusPlus Baltic OÜ või samasse kontserni kuuluv ettevõte.
              Kaubamärgid on kaitstud seaduse kohaselt ning nende kasutamine
              ilma kirjaliku loata on keelatud.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>12. Isikuandmete töötlemine</Summary>
        <Details>
          <ul>
            <li>
              Portaalihaldur/omanik töötleb Klientide isikuandmeid kooskõlas
              Privaatsuspoliitikaga.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>13. Tugi-, hooldus- ja arendusteenused</Summary>
        <Details>
          <ul>
            <li>
              13.1. Portaalihaldur uuendab pidevalt Iseteeninduse toimimise
              aluseks olevaid mehhanisme, et pakkuda Klientidele kvaliteetseid
              tooteid ja teenuseid. Sellest tulenevalt võib Portaalihaldur
              Iseteenindust ja selles keskkonnas sisalduvat muuta ning muuta
              nõudeid Iseteenindusele ja selle kaudu osutavate teenuste
              kasutamiseks vajalikule tark- ja riistvarale.{" "}
            </li>
            <li>
              13.2. Vajadusel võib Portaalihaldur peatada ajutiselt ligipääsu
              Iseteenindusele olukorras, kus see on vajalik Iseteeninduse
              muutmise, hooldamise ja uuendamise tarbeks.
            </li>
            <li>
              13.3. Juhul kui mistahes vigade või funktsionaalsushäirete korral
              on piiratud Iseteeninduse kasutamine, teeb Portaalihaldur kõik
              endast mõistliku eeldatava, et kõrvaldada häired esimesel
              võimalusel.
            </li>
          </ul>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>14. Lõppsätted</Summary>
        <Details>
          <ul>
            <li>
              14.1. Iseteeninduse Kasutajatingimustele ning Kliendi ja
              Portaalihalduri vahelistele lepingutele kohaldatakse Eesti
              Vabariigis kohalduvaid õigusakte.
            </li>
            <li>
              14.2. Pretensiooni korral tuleb Kliendil pretensioon esitada
              kirjalikult või kirjalikku taasesitamist võimaldavas vormis.
              Pretensioonis tuleb viidata asjaoludele ja/või dokumentidele,
              mille alusel pretensioon esitatakse. Kui Klient viitab
              pretensioonis dokumendile, mis ei ole Portaalihaldurile vabalt
              kättesaadav, tuleb see dokument pretensioonile lisada.
            </li>
            <li>
              14.3. Portaalihaldur vaatab pretensiooni läbi ja teatab otsusest
              kirjalikult või kirjalikku taasesitamist võimaldaval viisil
              hiljemalt 30 kalendripäeva jooksul alates pretensiooni
              vastuvõtmisest.
            </li>
            <li>
              14.4. Poolte vahel tekkinud vaidlused püütakse lahendada
              läbirääkimiste teel. Juhul kui vaidluste lahendamine
              läbirääkimiste teel ei õnnestu, lahendatakse Poolte vaidlused
              Harju Maakohtus, välja arvatud juhul kui seadusest tuleneb
              teisiti.
            </li>
            <li>14.5. Kasutajatingimused kehtivad alates xx.xx.2023.</li>
          </ul>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
